import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { DEFAULT_OBJECT } from '../constants';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    settings: {
      gradeDisabled: false,
      multipleProfiles: false,
    },
    courses: { data: [], included: [] },
    subscriptions: { data: [], included: [] },
    subscription: DEFAULT_OBJECT,
    campuses: { data: [], included: [] },
    sports: { data: [], included: [] },
    programs: { data: [] },
    course: DEFAULT_OBJECT,
    currentStudent: { data: { attributes: {} } },
    filters: {
      campus: undefined,
      sport: [],
      availability: undefined,
    },
    titleBar: {
      title: 'USPN Culture',
      backButton: false,
    },
    signUp: {
      firstname: '',
      kind: 'student',
      lastname: '',
      email: '',
      phone_number: '',
      password: '',
      password_confirm: '',
      student_number: '',
      female: undefined,
      program_id: undefined,
      consent: false,
    },
    subscriptionLoading: false,
    pendingSubscription: {},
    alert: {
      show: false,
      text: '',
      color: '',
      timeout: 3000,
    },
    subscriptionsFilter: 0,
  },
  mutations,
  actions,
  getters,
  modules: {
  },
});
